<!-- <button class="prev-arrow" (click)="prevSlide()">
  <i class="fa fa-angle-left"></i>
</button> -->
<owl-carousel-o [options]="BlogSliderConfig" class="no-arrow" #owlElement>
  <ng-container *ngFor="let blog of blogs">
    <ng-template carouselSlide>
      <div class="col-md-12">
        <a [routerLink]="'/pages/blog/details/' + blog.idBlog">
          <div class="blog-card">
            <div class="blog-image">
              <img [src]="blog.imagem" alt="" />
            </div>
            <div class="blog-details">
              <h4>{{ blog.dataPublicacao | date : "dd/MM/yyyy" }}</h4>
              <a [routerLink]="'/pages/blog/details/' + blog.idBlog">
                <p>{{ blog.titulo }}</p>
              </a>
              <hr class="style1" />
              <h6>{{ "by: " + blog.autor }} , {{ "2 Comentários" }}</h6>
            </div>
          </div>
        </a>
      </div>
    </ng-template>
  </ng-container>
</owl-carousel-o>
<button class="next-arrow" (click)="nextSlide()">
  <i class="fa fa-angle-right"></i>
</button>
